import { createContext } from 'react';

type SidePanelToggleContextValue = {
  isOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
};

export const SidePanelToggleContext = createContext<SidePanelToggleContextValue>({
  isOpen: false,
  openPanel: () => undefined,
  closePanel: () => undefined,
});
